import React from "react";
import FormatDateTime from "../../utils/formatDateTime";
const TableData = ({ data, ...props }) => {

  console.log("data",data)
  return (
    <div className="z-0 w-full h-[calc(100vh-60px)] custom-scroll overflow-x-auto  shadow-md animate-reveal transition-all duration-500 ease-in">
      <table className={` bg-black border border-gray-700 text-sm w-full relative z-0`}>
      <thead className="bg-[#0F0F0F] text-sm text-left">
        <tr className="text-white border-b border-gray-800">
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">S.No</th>
          {/* <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Exchnage Code</th> */}
          {/* <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Product Type</th> */}
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Stock Code</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Date Time</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Right</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Strike Price</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">LTP</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Spot Price</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">IV</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Delta</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Theta</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Gamma</th>
          <th className="border-r last-of-type:border-r-0 border-gray-800 px-4 py-3 font-semibold" scope="col">Vega</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((ele, i) => {
            return (
              <tr key={i} className="text-white border-b border-gray-800">
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{i+1}</td>
                {/* <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{ele?.exchange_code}</td> */}
                {/* <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{ele?.product_type}</td> */}
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{ele?.scrip_code}</td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{FormatDateTime(ele?.date)}</td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{ele?.right}</td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{ele?.strike_price}</td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{ele?.ltp}</td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{ele?.spot_price}</td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {parseFloat(ele?.iv).toFixed(4)}
                </td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {parseFloat(ele?.delta).toFixed(4)}
                </td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {parseFloat(ele?.theta).toFixed(4)}
                </td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">
                  {parseFloat(ele?.gamma).toFixed(4)}
                </td>
                <td className="px-4 py-2 border-r last-of-type:border-r-0 border-gray-900 text-white">{parseFloat(ele.vega).toFixed(3)}</td>
              </tr>
            );
          })}
      </tbody>
    </table>
    </div>
  );
};

export default TableData;
